import Service from '@/services'
import * as types from './mutation-types'

export const loading = ({
  commit
}) => {
  commit(types.LOADING);
}

export const loaded = ({
  commit
}) => {
  commit(types.LOADED);
}

export const login = ({
  commit
}, loginVm) => {
  Service.post('/Authentication/Login', loginVm)
    .then(function (response) {
      sessionStorage.setItem('token', response.data.token);
      Service.get("/Authentication/AccessCodes")
        .then(function(accessesResponse) {
          sessionStorage.setItem('accesses', accessesResponse.data);
        })
        .catch(function(error) {});
      commit(types.LOGIN);
      commit(types.REDIRECT);
    })
    .catch(function (error) {})
}

export const register = ({
  commit
}, registerVm) => {
  Service.post('/Authentication/Register', registerVm)
    .then(function (response) {
      commit(types.REGISTER);
    })
    .catch(function (error) {})
}

export const forgotPassword = ({
  commit
}, forgotPasswordVm) => {
  Service.post('/Authentication/ForgotPassword', forgotPasswordVm)
    .then(function (response) {
      commit(types.FORGOTPASSWORD);
    })
    .catch(function (error) {})
}

export const logout = ({
  commit
}) => {
  sessionStorage.removeItem("accesses");
  Service.get('/Authentication/Logout')
    .then((response) => {
      sessionStorage.removeItem("token");
      commit(types.LOGOUT);
    })
    .catch((error) => {
      sessionStorage.removeItem("token");
      commit(types.LOGOUT);
    })
}

export const enums = ({
  commit
}) => {
  Service.get(`/Dictionaries`)
    .then(function (response) {
      commit(types.ENUMS, response)
    }).catch(function (error) {})
}
